import { Field, ErrorMessage } from "formik";
import { get, set } from "lodash";
import axios from "axios";
import { useState } from "react";
import { IMAGE_URL } from "../../config";
import fileIcon from "../../assets/icons/file-line.svg";
import successToast from "../toast/successToast";
import errorToast from "../toast/errorToast";

export const FormMultiFileUploadField = ({
  label = "Upload Files",
  name = "files",
  labelClassName = "",
  className = "",
  previewClassName = "",
  accept = "*",
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});

  const handleFileChange = async (event, form, name) => {
    const token = localStorage.getItem("accessToken");
    const files = Array.from(
      event.target.files || event.dataTransfer?.files || []
    );
    if (!files.length) return;

    const uploadedFiles = [];

    const uploadFile = (file) => {
      const formData = new FormData();
      formData.append("file", file);

      return axios
        .post(IMAGE_URL, formData, {
          headers: {
            "x-access-token": token,
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress((prev) => ({
              ...prev,
              [file.name]: percent,
            }));
          },
        })
        .then((res) => {
          successToast(res?.data?.message || "Uploaded");
          uploadedFiles.push(res?.data?.data?.filePath);
        })
        .catch((err) => {
          console.error("Upload error", err);
          errorToast(err?.response?.data?.message || "Upload failed");
        });
    };

    Promise.all(files.map((file) => uploadFile(file))).then(() => {
      // setFileData([...fileData, ...uploadedFiles]);
      form.setFieldValue(name, [
        ...(get(form.values, name) || []),
        ...uploadedFiles,
      ]);
      setUploadProgress({});
    });
  };

  const handleRemoveFile = (form, name, index) => {
    const files = get(form.values, name) || [];
    const updated = [...files.slice(0, index), ...files.slice(index + 1)];
    const updatedValues = { ...form.values };
    set(updatedValues, name, updated);
    form.setValues(updatedValues);
  };

  const getFileName = (url) => {
    return url.substring(url.lastIndexOf("/") + 1);
  };

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const files = get(form.values, name) || [];
        const error = meta.touched && meta.error;

        console.log(files, "files");

        return (
          <>
            Files
            <div
              className={`flex flex-col gap-2 w-full ${className} pb-4 pt-2`}
              onDragOver={(e) => {
                e.preventDefault();
                setIsDragging(true);
              }}
              onDragLeave={(e) => {
                e.preventDefault();
                setIsDragging(false);
              }}
              onDrop={(e) => {
                e.preventDefault();
                setIsDragging(false);
                handleFileChange(e, form, name);
              }}
            >
              <label className="cursor-pointer w-full">
                <div
                  className={`border-[2px] border-dashed rounded-lg text-center w-full h-[200px] p-4 flex justify-center items-center gap-2 transition-all duration-200 ${
                    isDragging
                      ? "bg-blue-50 border-blue-400"
                      : error
                      ? "border-errorColor"
                      : "border-gray-400"
                  } text-primary`}
                >
                  <div className="flex flex-col items-center">
                    <img src={fileIcon} width={24} height={24} alt="file" />
                    <p className="text-fs_16 my-2">
                      {isDragging
                        ? "Drop files here"
                        : "Click or drag files to upload"}
                    </p>
                  </div>
                </div>
                <input
                  type="file"
                  accept={accept}
                  multiple
                  className="hidden"
                  onChange={(event) => handleFileChange(event, form, name)}
                />
              </label>

              {/* Upload Progress */}
              {Object.keys(uploadProgress).length > 0 && (
                <div className="mt-2 space-y-2">
                  {Object.entries(uploadProgress).map(([fileName, percent]) => (
                    <div
                      key={fileName}
                      className="rounded-xl border p-4 shadow-md w-full max-w-[30rem] flex justify-between items-center gap-2 bg-primary text-white"
                    >
                      <span className="truncate max-w-[80%] text-sm">
                        {fileName}
                      </span>

                      <div className="flex items-center gap-3">
                        <span className="text-sm">{percent}%</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className={`flex flex-col gap-2 mt-2 ${previewClassName}`}>
                {files.map((file, index) => (
                  <div
                    key={file}
                    className="rounded-xl border p-4 shadow-md w-full max-w-[30rem] flex justify-between items-center gap-2 bg-primary text-white"
                  >
                    <div className="text-sm font-medium truncate">
                      {getFileName(file)}
                    </div>
                    <div className="flex items-center gap-1">
                      <button
                        type="button"
                        onClick={() => handleRemoveFile(form, name, index)}
                        className="inline-block bg-errorColor text-white text-sm px-4 py-2 rounded hover:bg-red-700 hover:text-white"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                <ErrorMessage name={name} />
              </label>
            </div>
          </>
        );
      }}
    </Field>
  );
};
